import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import auth from './auth/auth'
import '@/assets/global.scss'

Vue.config.warnHandler = function (msg, vm, trace) {
  // console.warn(`[Vue warn]: ${msg}\n${trace}`)
}

Vue.config.productionTip = false

auth.authenticate(() =>
    new Vue({
      router,
      vuetify,
      render: h => h(App),
    }).$mount('#app'),
)
